var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColumnUnsorted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9733 5.82973L14.4333 8.28973C14.8233 8.67973 15.4533 8.67973 15.8433 8.28973C16.2333 7.89973 16.2333 7.26973 15.8433 6.87973L12.6733 3.69973C12.2833 3.30973 11.6533 3.30973 11.2633 3.69973L8.09328 6.87973C7.70328 7.26973 7.70328 7.89973 8.09328 8.28973C8.48328 8.67973 9.11328 8.67973 9.50328 8.28973L11.9733 5.82973ZM11.9733 18.1697L9.51328 15.7097C9.12328 15.3197 8.49328 15.3197 8.10328 15.7097C7.71328 16.0997 7.71328 16.7297 8.10328 17.1197L11.2733 20.2997C11.6633 20.6897 12.2933 20.6897 12.6833 20.2997L15.8533 17.1297C16.2433 16.7397 16.2433 16.1097 15.8533 15.7197C15.4633 15.3297 14.8333 15.3297 14.4433 15.7197L11.9733 18.1697Z",
    fill: "#668295"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnUnsorted);
export default __webpack_public_path__ + "static/media/column-unsorted.da0f4ee6e9e6fe6fb7bfcd27bd2097ef.svg";
export { ForwardRef as ReactComponent };